import { History } from 'lucide-react';
import { fmtTime } from './taUtils';

const ACTION = {
    record_start: 'Registró inicio', record_end: 'Registró fin', record_milestone: 'Registró hito',
    correct_time: 'Corrigió hora', delay_cause: 'Registró causa de demora', checklist: 'Checklist de rampa',
};
const FIELD = { actual_start: 'inicio', actual_end: 'fin', delay_cause: 'causa' };

const show = (v, tz) => {
    if (v === null || v === undefined) return '—';
    if (typeof v === 'object') return v.cause || JSON.stringify(v);
    return /^\d{4}-\d{2}-\d{2}T/.test(v) ? fmtTime(v, tz) : String(v);
};

export function AuditTrail({ entries, tz }) {
    return (
        <div className="space-y-2" data-testid="ta-audit">
            <h3 className="text-sm font-bold uppercase tracking-widest text-muted-foreground flex items-center gap-2"><History className="w-4 h-4" />Auditoría</h3>
            {!entries.length ? <p className="text-sm text-muted-foreground">Sin registros todavía.</p> : (
                <ul className="space-y-1.5 max-h-72 overflow-y-auto pr-1">
                    {entries.map(e => (
                        <li key={e.id} className="text-xs rounded-md border border-border/30 bg-muted/10 px-3 py-2" data-testid={`ta-audit-${e.id}`}>
                            <div className="flex flex-wrap gap-x-2">
                                <span className="font-mono text-muted-foreground">{fmtTime(e.created_at, tz)}</span>
                                <span className="font-semibold">{e.user_name}</span>
                                <span className="text-muted-foreground">({e.user_role})</span>
                                <span>{ACTION[e.action] || e.action}</span>
                                {e.activity_name && <span className="text-primary">· {e.activity_name}</span>}
                            </div>
                            {Object.entries(e.changes || {}).map(([k, c]) => (
                                <div key={k} className="font-mono text-[11px] text-muted-foreground">{FIELD[k] || k}: {show(c.before, tz)} → <span className="text-foreground">{show(c.after, tz)}</span></div>
                            ))}
                            {e.reason && <div className="text-[11px] italic text-amber-700 dark:text-amber-300">Motivo: {e.reason}</div>}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
